// parseFile.js
import axios from 'axios';

export async function parseFile(url) {
  const { data } = await axios.post(
    // put the /parseFile path here
    'https://australia-southeast1-positionprep-39660.cloudfunctions.net/api/parseFile',
    { url }
  );
  return data.text;
}
